export const TEST_ID = 'batteryDetailsPage';

export const CARD_HEADER_DETAIL_TYPE = 'battery';

export const DETAIL_TYPE_SERIAL_NUMBER = 'serialNumber';
